// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "ChatRoutingLogSummaryDto" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { ChatRoutingLogSource } from "./chat-routing-log-source.enum.gen";
import { ChatRoutingOutcome } from "./chat-routing-outcome.enum.gen";

export const ChatRoutingLogSummaryDtoGenShape = z.strictObject({
  id: z.string(),
  time: z.string(),
  configId: z.string().optional(),
  libraryId: z.string().optional(),
  source: z.enum(ChatRoutingLogSource),
  regressionRunId: z.string().optional(),
  regressionCaseId: z.string().optional(),
  conversationId: z.string().optional(),
  outcome: z.enum(ChatRoutingOutcome),
  errorClass: z.string().optional(),
  crisisFlags: z.array(z.string()),
  tenure: z.string().optional(),
  redactedInput: z.string(),
  matchCount: z.number(),
  shortlistCount: z.number(),
  coverageGapCount: z.number(),
  costUsd: z.number().optional(),
  totalMs: z.number().optional(),
  feedbackRating: z.number().optional(),
});
